import ReportsView from './reports-view';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../shared/state/root-reducer';
import {getConfiguration} from '../../shared/configuration/config-settings';
import {useEffect, useMemo} from 'react';
import {
  getClients
} from '../../implementation-specialist/state/clients/implementation-clients-thunk';
import {AppDispatch} from '../../shared/state/store';
import {LoadingOverlay} from '@finpay-development/shared-components';

const config = getConfiguration();

const AdminReportsView = () => {

  const userProfile = useSelector(
      (state: RootState) => state.userContext.userProfile,
  );
  const allClientsMap = useSelector(
      (state: RootState) => state.implementationContext.implementationSpecialistClient.allClientsMap);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(()=>{
    if(allClientsMap.size === 0){
      dispatch(getClients({includeFacility: true}))
    }
  }, [])

  const isVersion2 = useMemo(() => {

    if(allClientsMap.size > 0){
      return userProfile.allowedClients.every((client) => {
        if(client.clientId === 0) return false
        const clientDetails = allClientsMap.get(client.clientId);
        return clientDetails?.reportVersion === 2;
      });
    }
  }, [userProfile, allClientsMap]);

  if (isVersion2 === true) {
    window.location.href =
        config.app_environment === 'prod' ?
            `https://report.finpay.net/operations/reports` :
            `https://report.${config.app_environment}.finpay.net/operations/reports`;
  } else if(isVersion2 === false) {
    return (
        <ReportsView page="admin"/>
    );
  } else{
    return (
        <LoadingOverlay />
    )
  }
};

export default AdminReportsView;